"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var getCoordinates = function getCoordinates() {
  var coordinates = {
    x: 0,
    y: 0
  };
  var rect = document.getElementsByClassName('text-editor')[0].getBoundingClientRect();
  var LINK_POP_UP_WIDTH = 158.5;

  if (rect) {
    // Add to the offset
    coordinates.x += rect.width * 0.5 - LINK_POP_UP_WIDTH / 2;
    coordinates.y += rect.height * 0.5;
  }

  return coordinates;
};

var _default = getCoordinates;
exports["default"] = _default;
//# sourceMappingURL=getSelectionCoordinates.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-chart-editor/lib/components/widgets/text_editors/RichText/getSelectionCoordinates.js
// module id = 1040
// module chunks = 0